import MyFooter         from '../../../views/layout-footer'
import Breadcrumb       from '../../../views/breadcrumb'
import GridGenerator    from '../../../grids/grid-generator'
import DefinitionGetter
                        from '../../../../model/resource/getter/definitions-getter'
import DataGetter
                        from '../../../../model/resource/getter/data-getter'
import FormElementTypes from '../../../../model/FormElementTypes'
import InputBox         from '../../../forms/elements/InputBox'
import Swal             from 'sweetalert2/dist/sweetalert2.js'
import interpretations  from '../../../../model/interpretations'
import Bootbox          from '../../../../model/Bootbox'
import ResourceGetter
                        from '../../../../model/resource/getter/resource-getter'
import CartRefresh
                        from '../../../../model/event-handlers/cart-refresh-event'
import BusinessRuleResponseHandler
                        from '../../../../model/response-handlers/bussines-rule-response-handler'
import FormGenerator    from '../../../forms/FormGenerator'
import ValueTypeConverter
                        from '../../../../model/converter/ValueTypeConverter'

export default {
  components: {
    MyFooter,
    GridGenerator,
    Breadcrumb,
    InputBox,
    FormGenerator
  },

  props: [
    'menuField',
    'row',
    'scrollFiredProp',
    'idStructure'
  ],

  data () {
    return {
      def:              null,
      page:             this.$route.params.page,
      h1:               '',
      breadcrumbItems:  [],
      gridDef:          {},
      headerData:       null,
      formElements:     { buttons: [], others: [] },
      clickedButtonDef: null
    }
  },

  created () {
    this._initBase()
  },

  methods: {

    _initBase () {
      this._initDefinitions()
          .then(() => {
            this._initData()
          })
          .catch((error) => this.handleApiError(error))
    },

    /**
     * @private
     */
    _initDefinitions () {
      this.def = undefined

      let success = (def) => {
            this.def            = def
            this.innerMenuField = def.response.data[0]
            this.h1             = this.def.dictionaryKeyCode
            this._setBreadcrumbs()
            this._prepareGridDef()
            this._prepareFormElements()
          },
          error   = (error) => {
            this.handleApiError(error)
          },
          args    = {
            code:                   this.page,
            idtEntityStructureFrom: this.idStructure
          }

      return DefinitionGetter.getDataDefinition(args, success, error)
    },

    _initData () {
      const success = (response) => {
        this.headerData = response.data[0]
      }

      const dataGetter  = new DataGetter()
      dataGetter.def    = this.def
      dataGetter.offset = this.offset
      dataGetter.user   = this.$store.getters.user

      return dataGetter.get(success, (error) => {this.handleApiError(error)})
    },

    /**
     *
     * @private
     */
    _setBreadcrumbs () {
      this.breadcrumbItems = []
      this.breadcrumbItems.push({ name: 'Dashboard', label: 'Home' })
      this.breadcrumbItems.push({ name: this.h1, label: this.h1, active: true })
    },

    /**
     *
     * @private
     */
    _prepareGridDef () {
      this.def.list.forEach((item) => {
        if (item.FieldType === FormElementTypes.enuEntForm) {
          this.gridDef.page         = item.Code
          this.gridDef.idtStructure = item.idtEntityStructureFrom
          return
        }
      })
    },

    _prepareFormElements () {
      this.def.editor.forEach((item) => {
        if (item.FieldType === FormElementTypes.enuFormAction) {
          this.formElements.buttons.push(item)
          return
        }

        this.formElements.others.push(item)
      })
    },

    /**
     *
     * @param data
     * @private
     */
    _formSubmit (data) {
      if (!this.clickedButtonDef) {
        throw new Error('Button definition not set!')
      }

      const process = () => {
        const where    = '',
              resource = ResourceGetter.get(this.def.viewName)

        let args = {
          ruleType: 'Action',
          ruleName: this.clickedButtonDef.ViewName,
          where:    where,
          value:    data.data
        }
        resource
          .setDef(this.def)
          .callBusinessRule(args)
          .then((response) => {

            if (response.data.messages) {
              Swal.fire(response.data.messages, '')
            }

            CartRefresh.exec()
            BusinessRuleResponseHandler.handleResponse(response, this.$router)
            window.location.reload()

          })
          .catch((error) => {this.handleApiError(error)})
      }

      const submitForm = () => {
        const resource = ResourceGetter.get(this.def.viewName)

        resource
          .setDef(this.def)
          .update(data)
          .then(response => {
            let data = response.data[0]

            process()
          }).catch(error => {
          this.handleApiError(error)
        })
      }

      if (this.clickedButtonDef.Interpretation === interpretations.buttonS) {
        Bootbox.message    = this.$translate.text('cfm_confirm_message') +
          ' "' + this.$translate.text(this.clickedButtonDef.Label) + '" ?'
        Bootbox.title      = this.$translate.text('cfm_confirm') + ' ?'
        Bootbox.translator = this.$translate
        Bootbox.init(() => {
          submitForm()
        })

      }
      else {
        submitForm()
      }
    },

    /**
     * @TODO: duplicated code - in PageDynamicEditor -> MUST BE REFACTORED!!!
     * @param args
     * @private
     */
    _callBusinessRules (args) {

      let formCalrecCallback = () => {
        // volani calrec nad celym formularem pokud je definovan
        if (this.def.calRec) {
          let value      = Object.assign({}, this.innerDefaults),
              formValues = this.$refs.form._prepareSubmitData()

          Object
            .keys(formValues)
            .map(key => {
              value[key] = formValues[key]
            })

          let options = {
                ruleType:   'CALREC',
                ruleName:   this.def.calRec,
                where:      this.subFormWhereCondition,
                columnName: args
                              ? args.element.field
                              : null,
                value:      value
              },
              promise = this
                .resource
                .setDef(this.def)
                .callBusinessRule(options)
                .then((response) => {

                  Object
                    .keys(response.data.values)
                    .map(key => {
                      let stValue = response.data.values['ST' + key]
                        ? response.data.values['ST' + key]
                        : response.data.values[key],
                          values  = {
                            value:   response.data.values[key],
                            stValue: stValue
                          }

                      this.$refs.form.setValue(key, values)
                      this.innerDefaults[key] = response.data.values[key]
                    })

                  this._prepareListIcons()
                  this._prepareListImages()

                  if (response.data.messages) {
                    Swal.fire(response.data.messages, '')
                  }

                }).catch((error) => {
                  this.handleApiError(error)
                })

          this.businessRuleCallStack.push(promise)
        }
      }

      if (!args) {
        formCalrecCallback()

        return
      }

      // volani calrec nad elementem formulare pokud je definovan
      if (args.element.calrec) {
        let values = Object.assign({}, this.innerDefaults),
            value  = args.value

        args.element.type = args.element.dataType // TODO: hack -> v
                                                  // FormValuesCollection je
                                                  // treba predelat propertu
                                                  // type na dataType !!

        if (args.element.dataType === 'nvarchar'
          && args.hasOwnProperty('stValue')
          && (args.element.field === args.element.fieldView)) {
          value = args.stValue
        }
        else {
          value = ValueTypeConverter.convert(args.element, value)
        }

        values[args.element.field] = value

        let options = {
              ruleType:   'CALREC',
              ruleName:   args.element.calrec,
              where:      this.subFormWhereCondition,
              columnName: args.element.field,
              value:      values
            },
            promise = this
              .resource
              .setDef(this.def)
              .callBusinessRule(options)
              .then((response) => {
                Object
                  .keys(response.data.values)
                  .map(key => {
                    let stValue = response.data.values['ST' + key]
                      ? response.data.values['ST' + key]
                      : response.data.values[key],
                        values  = {
                          value:   response.data.values[key],
                          stValue: stValue
                        }

                    this.$refs.form.setValue(key, values)
                    this.innerDefaults[key] = response.data.values[key]
                  })

                this._prepareListIcons()
                this._prepareListImages()

                if (response.data.messages) {
                  Swal.fire(response.data.messages, '')
                }

                formCalrecCallback()

              }).catch((error) => {
                // nastaveni puvodni hodnoty pokud dojde k nejakemu problemu
                let originalValue = this.$refs.form
                                        .getOriginalValues()
                                        .getValue(args.element.field)
                this.$refs.form
                    .setValue(args.element.field, { value: originalValue })

                this.handleApiError(error)
              })

        this.businessRuleCallStack.push(promise)

        return
      }

      formCalrecCallback()
    },

    _submit (buttonDef) {
      if (this.def.isReadOnly !== 'disable') {
        return
      }
      this.clickedButtonDef = buttonDef

      this.$refs.form.submit()
    },

    formButtonClicked () {
      this.headerData = null
      this._initData()
    }

  }

}
